import React from 'react';

import Attribute from './attribute/common';
import NotCatCD from './attribute/not-cat-cd';
import NotCatSN from './attribute/not-cat-sn';
import NotImported from './attribute/not-imported';
import OriginalNumberPlate from './attribute/original-number-plate';
import OriginalColour from './attribute/original-colour';

export interface Props {
    notCatCD: boolean;
    notCatSN: boolean;
    notImported: boolean;
    originalNumberPlate: boolean;
    originalColour: boolean;
}

const ExtendedReport: React.FC<Props> = ({
    notCatCD,
    notCatSN,
    notImported,
    originalNumberPlate,
    originalColour,
}) => (
    <ul data-q="enhanced-motors-vhc-badge" data-testid="extended-report-text">
        <Attribute name="Not stolen" passed />
        <Attribute name="Not scrapped" passed />
        <Attribute name="Not exported" passed />
        <Attribute name="Not Cat A/B" passed />
        <NotCatCD passed={notCatCD} />
        <NotCatSN passed={notCatSN} />
        <NotImported passed={notImported} />
        <OriginalNumberPlate passed={originalNumberPlate} />
        <OriginalColour passed={originalColour} />
    </ul>
);

export default ExtendedReport;
